import { formatData, sortByDateReverse } from "./utils";
import { isEmpty } from "lodash";

export function getAllReturnProducts(){
    return async function(dispatch){

        try {
            const response = await fetch('/returns/getAll',{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            }); 
            
            const prodList = await response.json()
            console.log({prodList})
    
                // /!\ must check err !!
            if(prodList.list){
                console.log('====================================');
                console.log("[INFO] FETCH PRODUCTS", prodList);
                console.log('====================================');
                let prods =  formatData(sortByDateReverse(prodList.list, "creation_date"))
                // let prods = formatData(prodList.list.reverse())
                
                console.log({ prods });
                
                dispatch({
                    type: "GET_RETURN_PRODUCTS",
                    payload: prods
                })
                dispatch({
                    type: "FETCH_RETURN_PRODUCT_FULFILLED",
                    payload: ""
                })
            } else {

                console.log('====================================');
                console.log("[ERROR] FETCH PRODUCTS", prodList);
                console.log('====================================');
                dispatch({
                    type: "FETCH_RETURN_PRODUCT_ERROR",
                    payload: "error fetching products" // send err
                })
            }
            
            
        } catch (err) {
            console.log('====================================');
            console.log("[ERROR] FETCH PRODUCTS", err);
            console.log('====================================');dispatch({
                type: "FETCH_RETURN_PRODUCT_ERROR",
                payload: err
            })
            return err
        }
    }
        
}
export function getAllReturnSales(){
    return async function(dispatch){

        try {
            const response = await fetch('/returns/sales/getAll',{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            }); 
            
            const saleList = await response.json()
            console.log({saleList})
    
                // /!\ must check err !!
            if(saleList.list){
                console.log('====================================');
                console.log("[INFO] FETCH SALES", saleList);
                console.log('====================================');
                // let sales = formatData(saleList.list.reverse())
                let sales = formatData(sortByDateReverse(saleList.list, "date"))
                
                console.log({ sales });
                
                dispatch({
                    type: "GET_RETURN_SALES",
                    payload: sales
                })
                dispatch({
                    type: "FETCH_RETURN_SALES_FULFILLED",
                    payload: ""
                })
            } else {

                console.log('====================================');
                console.log("[ERROR] FETCH SALES", saleList);
                console.log('====================================');
                dispatch({
                    type: "FETCH_RETURN_SALES_ERROR",
                    payload: "error fetching sales" // send err
                })
            }
            
            
        } catch (err) {
            console.log('====================================');
            console.log("[ERROR] FETCH SALES", err);
            console.log('====================================');dispatch({
                type: "FETCH_RETURN_SALES_ERROR",
                payload: err
            })
            return err
        }
    }
        
}
export function getAllReturnStocks(){
    return async function(dispatch){

        try {
            const response = await fetch('/returns/stocks',{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            }); 
            
            const stockList = await response.json()
            console.log({stockList})
    
                // /!\ must check err !!
            if(stockList.list){
                console.log('====================================');
                console.log("[INFO] FETCH STOCKS", stockList);
                console.log('====================================');
                let stocks = formatData(stockList.list.reverse(), "return_product_id")
                
                console.log({ stocks });
                
                dispatch({
                    type: "GET_RETURN_STOCKS",
                    payload: stocks
                })
                dispatch({
                    type: "FETCH_RETURN_STOCK_FULFILLED",
                    payload: ""
                })
            } else {

                console.log('====================================');
                console.log("[ERROR] FETCH STOCKS", stockList);
                console.log('====================================');
                dispatch({
                    type: "FETCH_RETURN_STOCK_ERROR",
                    payload: "error fetching stocks" // send err
                })
            }
            
            
        } catch (err) {
            console.log('====================================');
            console.log("[ERROR] FETCH STOCKS", err);
            console.log('====================================');dispatch({
                type: "FETCH_RETURN_STOCK_ERROR",
                payload: err
            })
            return err
        }
    }
        
}

// addInReturn
export function createReturnProduct(newProd){
    // console.log("FIRED ACTION CREATE PRODUCT", newProduct)
    //return async function(dispatch){
    return async dispatch => new Promise(async function(resolve, reject) {
        dispatch({
            type: "CREATE_RETURN_PRODUCT_START",
            payload: ""
            
        })
        try {
            
            const response = await fetch('/returns/new',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    data:newProd
                }),
                credentials: 'same-origin',
            }); 
            
            const createdProduct = await response.json()
            console.log(createdProduct)// createdProduct returns new object created

            if(createdProduct.id){ // no errors, return new Object
                createdProduct.src = [] // array to save photos src URI
                dispatch({
                    type: "NEW_RETURN_PRODUCT",
                    payload: createdProduct
                })
                // dispatch({
                //     type: "UPDATE_SALE_ITEM_QTY",
                //     payload: {id: createdProduct.sale_item_id, sale_id: createdProduct.sale_id, rest_to_return: createdProduct.rest_to_return}
                // })
                    
                dispatch({ type: "CREATE_RETURN_PRODUCT_FULFILLED", payload:"" })
                console.log("Product created")
                resolve("Product created")
            } else {
                console.log("[ERROR] SUBMIT CREATE_RETURN_PRODUCT_ERROR ", createdProduct);
                
                dispatch({
                    type: "CREATE_RETURN_PRODUCT_ERROR",
                    payload: createdProduct.error
                })
                reject(createdProduct.error);
            }
            
        } catch (err) {
            console.log("[ERROR] SUBMIT RETURN_PRODUCT ", err);
            dispatch({ type: "CREATE_RETURN_PRODUCT_ERROR", payload: err })
            reject(err);
        }
    })
}
// Delete Return
export function deleteReturnProduct(prodID){
    //return async function(dispatch){
    return async dispatch => new Promise(async function(resolve, reject) {

        dispatch({ type: "DELETE_RETURN_PRODUCT_START", payload: "" })
        
        try {
            const response = await fetch('/returns/delete',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    data:prodID
                }),
                credentials: 'same-origin',
            }); 
            
            const res = await response.json()
            console.log("deleteReturnProduct", {res})

            if(!res.error){
                dispatch({
                    type: "DELETE_RETURN_PRODUCT",
                    payload: prodID
                    
                })
                dispatch({ type: "DELETE_RETURN_PRODUCT_FULFILLED", payload:"" })
                dispatch(getAllReturnStocks())
                console.log("Product deleted")
                resolve("Product deleted")
            } else {
                dispatch({
                    type: "DELETE_RETURN_PRODUCT_ERROR",
                    payload: res.error
                })
                reject(res.error);
            }
            
        } catch (err) {
            console.log("[ERROR] DELETE RETURN_PRODUCT ", err);
            dispatch({ type: "DELETE_RETURN_PRODUCT_ERROR", payload: err })
            reject(err);
        }
    })
}

// addInReturn
export function createReturnSale(newProd){
    // console.log("FIRED ACTION CREATE SALE", newSale)
    return async dispatch => new Promise(async function(resolve, reject) {
        dispatch({
            type: "CREATE_RETURN_SALE_START",
            payload: ""
            
        })
        try {
            
            const response = await fetch('/returns/sale/new',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    data:newProd
                }),
                credentials: 'same-origin',
            }); 
            
            const createdSale = await response.json()
            console.log(createdSale)// createdSale returns new object created

            if(createdSale.id){ // no errors, return new Object
                
                dispatch({
                    type: "NEW_RETURN_SALE",
                    payload: createdSale
                })
                dispatch({ type: "CREATE_RETURN_SALE_FULFILLED", payload:"" })
                dispatch(getAllReturnSales())
                console.log("Sale created")
                resolve("Sale created")
            } else {
                console.log("[ERROR] SUBMIT CREATE_RETURN_SALE_ERROR ", createdSale);
                dispatch({
                    type: "CREATE_RETURN_SALE_ERROR",
                    payload: createdSale.error
                })
                reject(createdSale.error);
            }
            
        } catch (err) {
            console.log("[ERROR] SUBMIT RETURN_SALE ", err);
            dispatch({ type: "CREATE_RETURN_SALE_ERROR", payload: err })
            reject(err);
        }
    })
}

// Delete Return Sale
// saleData can be either a string (saleID only, for backward compatibility) or an object {saleID, password}
export function deleteReturnSale(saleData){
    const methodName = "deleteReturnSale"
    //return async function(dispatch){
    return async dispatch => new Promise(async function(resolve, reject) {        
        try {
            // Handle both old format (string) and new format (object with password)
            const requestData = typeof saleData === 'string' ? saleData : saleData;
            const saleID = typeof saleData === 'string' ? saleData : saleData.saleID;
            
            const response = await fetch('/returns/delete/sale',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    data: requestData
                }),
                credentials: 'same-origin',
            }); 
            
            const res = await response.json()
            console.log("[DEBUG]",methodName, {res})

            // Backend now returns an object with {success: true/false, message: "..."}
            if(!res.error && (res === 'ok' || res.success === true || res.message)){
                dispatch({
                    type: "DELETE_RETURN_SALE",
                    payload: saleID
                })
                dispatch(getAllReturnStocks())
                console.log("[DEBUG]",methodName,"Sale deleted")
                resolve("Sale deleted")
            } else {
                const errorMessage = res?.error?.message || res?.error || res?.message || "Erreur lors de la suppression";
                reject(errorMessage);
            }
            
        } catch (err) {
            console.log("[DEBUG]",methodName," RETURN_PRODUCT ", err);
            reject(err);
        }
    })
}